import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestForm.standalone.DescriptionSection', {
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Describe for what you need an approval.',
    exceededDescriptionLengthErrorText: 'Max length of description is {maxLength}.',
});
